export default __webpack_public_path__ + "static/media/038-fire-alarm-1.015d1532.png";